import { State, StateContext, NgxsOnInit, Action } from '@ngxs/store';
import { EndBusyMessage, StartBusyMessage } from './app.state.actions';

export interface AppStateModel {
	busyMessage: string;
	showBusyMessage: boolean;
}

@State<AppStateModel>({
	name: 'app',
	defaults: {
		busyMessage: 'busy',
		showBusyMessage: false
	}
})
export class AppState implements NgxsOnInit {
	constructor() {}

	async ngxsOnInit(ctx: StateContext<AppStateModel>) {}

	@Action(StartBusyMessage)
	handleStartBusyMessage(ctx: StateContext<AppStateModel>, action: StartBusyMessage) {
		ctx.patchState({
			busyMessage: action.message,
			showBusyMessage: true
		});
	}

	@Action(EndBusyMessage)
	handleEndBusyMessage(ctx: StateContext<AppStateModel>) {
		ctx.patchState({
			busyMessage: 'busy',
			showBusyMessage: false
		});
	}
}
